/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { EntityId } from '../../../../types/api/EntityId';

export type UpdateClusterDataForm = {
  projectId: EntityId;
};

export const initialFormValues: UpdateClusterDataForm = {
  projectId: '',
};

export const validationSchema = Yup.object({
  projectId: Yup.string().required('empty'),
});
